export default "__VITE_ASSET__BF9WWL4z__"